export const CyPlaylistIndex = {
  PlaylistPageHeader: "PlaylistPageHeader",
  PlaylistTitle: "PlaylistTitle",
  ButtonAddPlaylist: "ButtonAddPlaylist",
  ShowAllPlaylistsLink: "ShowAllPlaylistsLink",
  RecentPreviews: "RecentPreviews",
  RecentPreview: "RecentPreview",
  ButtonSaveRecentPreview: "ButtonSaveRecentPreview",
  ButtonRemoveRecentPreview: "ButtonRemoveRecentPreview",
} as const;
